import { AppState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: AppState = {
  fallbackRoute: '',
  isLoading: false,
  userAgent: undefined
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
